import styled from 'styled-components';
import { CrossSolid } from '@simplywallst/ui-core/icons';
import { Row, media } from '@simplywallst/ui-core';

export const Container = styled(Row)`
  position: relative;
  background: white;
  width: 100%;
  max-width: 384px;
  border-radius: 6px;
  ${media.lgUp`
    max-width: 877px;
    min-height: 356px;
  `}
`;

export const EmailFormWrapper = styled('div')`
  max-width: 320px;
  margin-top: -${({ theme }) => theme.x1space}rem;
  margin-left: auto;
  margin-right: auto;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x4spacePx}px;
  `}
`;

export const CloseIcon = styled(CrossSolid)`
  cursor: pointer;
  position: absolute;
  right: ${({ theme }) => theme.x1spacePx}px;
  top: ${({ theme }) => theme.x1spacePx}px;
  fill: ${({ theme }) => theme.color.white};
  z-index: 1;
  fill: ${({ theme }) => theme.color.black};
`;
